import {useState, useEffect} from 'react';
import { postAddCard,  getCardList } from 'services/Cards'
import { useToken } from 'hooks/useToken'
import { useHistory } from 'react-router-dom'
import { decodeStorage, encodeStorage, removeStorage } from 'functions/storageBase64';
import { BASE_PATH, SUB_DIRECTORY, BASE_PATH_PORTAL } from 'constants/general'


export function useAddCard(){
    const { newToken, liveToken }  = useToken()
    const history = useHistory()
    const session_token = decodeStorage('session_token')
    const sears_numero_internet = decodeStorage('sears_numero_internet')
    const cardending = decodeStorage('cardending')
    const addCardPreLogin = decodeStorage('addCardPreLogin')
    const [errorCode, setErrorCode] = useState()

    const [responseCardList, setResponseCardList] = useState()
    const [addCardNew, setAddCardNew] = useState(false)

    useEffect(()=>{
        if(session_token){
            if((!sears_numero_internet || sears_numero_internet === "undefined") && (!cardending || cardending === 'undefined')){
                liveToken()
                getCardList()
                .then(setResponseCardList)
            }
        }
    },[newToken, addCardNew])

    useEffect(()=>{
        if(responseCardList?.statusCode === 200){
            encodeStorage('sears_numero_internet', responseCardList?.data?.cards[0].no_internet)
            encodeStorage('cardending', responseCardList?.data?.cards[0].card_ending)
            window.location.reload()
        }
    },[responseCardList])


    /* ---- agega tarjetas para asociarlos a un usuario --- */
    const [addCard, setAddCard] = useState(false)
    const [cardTrue, setCardTrue] = useState()
    const [cardendingPrev, setCardendingPrev] = useState(false)
    const addNewCard = (value) => {
        setAddCard(value)
    }

    const [loading, setLoading] = useState(false)
    
    useEffect(()=>{
        if(addCard){
            //console.log('1')
            //console.log('addCard1 :',addCard)
            if(sears_numero_internet && sears_numero_internet != "undefined"){
                //console.log('1-1')
                setCardendingPrev(addCard.cardnumber.substr(-4))
                liveToken()
                postAddCard(addCard)
                .then(setCardTrue)
                //setLoading(true)
            }
            else if(!session_token){
                //console.log('1-2')
                encodeStorage('addCardPreLogin', addCard)
                window.location.assign(`${BASE_PATH_PORTAL}/login?redirect=${window.location.href}`)
            }
            else{
                //console.log('1-3')
                setCardendingPrev(addCard.cardnumber.substr(-4))
                encodeStorage('addCardPreLogin', addCard)
                liveToken()
                postAddCard(addCard)
                .then(setCardTrue)
                //setLoading(true)
            }
        }
        else if(addCardPreLogin && addCardPreLogin != "undefined"){
            if(session_token){
                //console.log('2')
                if(sears_numero_internet && sears_numero_internet != "undefined"){
                    //console.log('2-1')
                    removeStorage('addCardPreLogin')
                    history.replace(`${BASE_PATH}${SUB_DIRECTORY}oldHome`)
                    setLoading(false)
                }
                else{
                    //console.log('2-2')
                    setCardendingPrev(addCardPreLogin.cardnumber.substr(-4))
                    liveToken()
                    postAddCard(addCardPreLogin)
                    .then(setCardTrue)
                    setLoading(true)
                }
            }
            else{
                removeStorage('addCardPreLogin')
                setLoading(false)
            } 
        }

    },[addCard])

    useEffect(()=>{
        if(cardTrue){
            console.log('cardTrue: ', cardTrue)
            console.log('cardendingPrev: ', addCard)
            console.log('cardendingPrev: ', addCard.cardnumber)
            console.log('cardendingPrev: ', addCard.cardnumber.substr(-4))

            if(cardTrue.statusCode === 200){
                if(cardTrue.data){
                    encodeStorage('sears_numero_internet', cardTrue?.data?.noInternet)
                    encodeStorage('cardending', addCard?.cardnumber?.substr(-4))
                    removeStorage('addCardPreLogin')
                    history.replace(`${BASE_PATH}${SUB_DIRECTORY}oldHome`)
                }
            }
            else if(cardTrue.statusCode === 400){
                let codeError = JSON.parse(cardTrue.data)
                setErrorCode(codeError)
                if(codeError.codMen === "ERR007"){
                    removeStorage('lastConsultData')
                    removeStorage('addCardPreLogin')
                    //window.location.reload()
                }
                if(codeError.codMen === "ERR011"){
                    removeStorage('lastConsultData')
                    removeStorage('addCardPreLogin')
                    //validar despues 
                    //window.location.reload()
                }
            }
            else if(cardTrue.statusCode >= 500){
                removeStorage('lastConsultData')
                removeStorage('addCardPreLogin')
                setErrorCode(cardTrue.statusCode)
                setLoading(false)
            }
        }      
    },[cardTrue, addCard])

    return{
        addNewCard,
        loading,
        errorCode
    }
}